const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const AUTHORIZATION_KEY = "Authorization";
const LOGIN_KEY = "logIn";

export const saveLocalStorage = (uniqueKey, obj) => {
  localStorage.setItem(uniqueKey, JSON.stringify(obj));
};

export const getLocalStorage = (uniqueKey) => {
  const data = localStorage.getItem(uniqueKey);
  if (data) {
    const parseData = JSON.parse(data);
    return parseData;
  }
  return null;
};

// export const clearTokensFromLocalStorage = () => {
//   localStorage.removeItem(AUTHORIZATION_KEY);
// };
